export default function ValuePropositionCards() {
  const cards = [
    {
      icon: 'ri-flashlight-line',
      title: 'Gerçek Zamanlı Tarama',
      description: 'Yüzlerce hisse senedi anlık olarak taranır ve değerlendirilir. Piyasadaki fırsatları kaçırmayın.',
      features: ['Anlık Veri Akışı', 'Otomatik Tarama', 'Hızlı Sonuçlar']
    },
    {
      icon: 'ri-brain-line',
      title: 'Akıllı Karar Motoru',
      description: 'Karmaşık piyasa verilerini analiz eder ve sade alım–izleme kararlarına dönüştürür.',
      features: ['Yapay Zeka Destekli', 'Net Kararlar', 'Yüksek Doğruluk']
    },
    {
      icon: 'ri-dashboard-line',
      title: 'Yüzlerce Hissede Tek Ekran Takip',
      description: 'Tüm piyasayı tek bir ekranda görün. Karmaşık grafiklere gerek yok, sadece net kararlar.',
      features: ['Tek Ekran', 'Kolay Takip', 'Sade Arayüz']
    },
    {
      icon: 'ri-global-line',
      title: 'Tarayıcı Üzerinden Erişim',
      description: 'Herhangi bir cihazdan, tarayıcınız üzerinden anında erişin. Kurulum gerektirmez.',
      features: ['Kurulum Yok', 'Her Cihazdan', 'Anında Erişim']
    },
  ];

  return (
    <section className="py-24 bg-dark relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="relative w-[400px] h-[400px]">
          <div className="absolute top-0 left-1/4 w-48 h-48 bg-emerald/20 rounded-full blur-[120px]"></div>
          <div className="absolute bottom-0 right-1/4 w-48 h-48 bg-emerald-light/18 rounded-full blur-[120px]"></div>
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-40 h-40 bg-emerald/12 rounded-full blur-[100px]"></div>
        </div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-emerald/10 border border-emerald/20 rounded-full mb-6">
            <i className="ri-star-line text-emerald"></i>
            <span className="text-sm font-medium text-beige-light">Avantajlar</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-beige-light mb-4">
            Neden BAGA?
          </h2>
          <p className="text-xl text-beige max-w-2xl mx-auto">
            Hisse senedi yatırımlarınızı bir üst seviyeye taşıyacak özellikler
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
          {cards.map((card, index) => (
            <div
              key={index}
              className="group relative bg-dark-card border border-dark-border rounded-2xl p-8 hover:border-emerald/50 transition-all duration-300 hover:shadow-lg hover:shadow-emerald/10 hover:-translate-y-2"
            >
              {/* Icon */}
              <div className="w-16 h-16 bg-gradient-to-br from-emerald/20 to-emerald-light/20 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${card.icon} text-3xl text-emerald`}></i>
              </div>

              {/* Content */}
              <h3 className="text-2xl font-bold text-beige-light mb-4 group-hover:text-emerald transition-colors">
                {card.title}
              </h3>
              <p className="text-beige leading-relaxed mb-6">
                {card.description}
              </p>

              {/* Features List */}
              <ul className="space-y-3">
                {card.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <i className="ri-check-line text-emerald text-xl flex-shrink-0 mt-0.5"></i>
                    <span className="text-beige text-sm">{feature}</span>
                  </li>
                ))}
              </ul>

              {/* Hover Effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-emerald/5 to-transparent rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
